<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top menuName="设置" prevUrl="/WeChat/Person">
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="22">
				个人信息 
			</Col>
		</Row> -->
		
		<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;">
			<Col span="6" style="padding-left: 16px;">
				关于
			</Col>
			<Col span="16" style="text-align: right;">
			</Col>
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
			</Col>
		</Row>
	</div>
</template>
<script>
	import Top from '../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Setting/index.vue